import Vue from 'vue'
import Vuex from 'vuex'
import requst from '../utils/serve/request'
import { routerListA } from "../router/routerList";
import router from '../router'
import i18n from '../utils/lang/i18n'
import ElementUI from 'element-ui';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    platformData: {},
    indexActive: [],
    routerPath: {},
    defaultActive: null,
    newRouterList: [],
    regionList: [{
      text: i18n.t('config.text1'),
      id: 'cn'
    }, {
      text: i18n.t('config.text2'),
      id: 'jp'
    }, {
      text: i18n.t('config.text3'),
      id: 'usa'
    },
    {
      text: i18n.t('config.text4'),
      id: 'eur'
    },
    {
      text: i18n.t('config.text35'),
      id: 'sea'
    }],
    currentRegion: 0
  },
  mutations: {
    //切换区域
    switchRegionIndex(state, e) {
      state.currentRegion = e;
    },
    setDefaultActive(state, e) {
      state.defaultActive = "/" + e.path.split("/")[1];
    },
    //设置平台方信息
    setInfoByDomain(state, e) {
      if (localStorage.getItem('lang')) {
        if (localStorage.getItem('lang') == 'zh-CN') {
          i18n.locale = 'zh-CN'
        }
        if (localStorage.getItem('lang') == 'ja-Jp') {
          i18n.locale = 'ja-Jp'
        }
        if (localStorage.getItem('lang') == 'en-US') {
          i18n.locale = 'en-US'
        }
      } else {
        if (e.region == 'cn') {
          i18n.locale = 'zh-CN'
        }
        if (e.region == 'jp') {
          i18n.locale = 'ja-Jp'
        }
        if (e.region == 'eur') {
          i18n.locale = 'en-US'
        }
        if (e.region == 'usa') {
          i18n.locale = 'en-US'
        }
        if (e.region == 'sea') {
          i18n.locale = 'en-US'
        }
      }


      state.platformData = e;

      if (typeof e.platformAdminBackground == 'string') {
        state.platformData.platformAdminBackground = JSON.parse(e.platformAdminBackground)
      }
      if (typeof e.platformAdminLogo == 'string') {
        state.platformData.platformAdminLogo = JSON.parse(e.platformAdminLogo)
      }
      if (e.id == 10000) {
        document.title = 'DEEBIKE';
      } else {
        document.title = e.platformAdminName;
      }
      // var link = document.createElement('link');
      // link.type = 'image/x-icon';
      // link.rel = 'shortcut icon';
      // link.href = JSON.parse(e.platformAdminLogo).imagePath;
      // document.getElementsByTagName('head')[0].appendChild(link);
      // console.log(i18n.t('config.text3'));
    },
    //设置当前页面路由
    setRouterPath(state, e) {
      setTimeout(() => {
        if (state.newRouterList.length < 1) {
          return
        }
        let arr = state.newRouterList[0].children.filter((item) => {
          return item.path == e.path.split("/")[1];
        });

        // let arr = routerList[0].children.filter((item) => {
        //   return item.name == e.path.split("/")[1];
        // });
        if (arr.length < 1) {
          return
        }

        state.routerPath = arr[0];
        let paths = e.path.split("/");
        paths.splice(0, 1);
        if (paths.length < 2) {
          for (let i in state.routerPath.children) {
            if (state.routerPath.children[i].alias != undefined) {
              for (let j in state.routerPath.children[i].children) {
                if (state.routerPath.children[i].children[j].alias != undefined) {
                  state.indexActive = [i, j];
                }
              }
            }
          }
        } else {
          for (let i in state.routerPath.children) {
            if (state.routerPath.children[i].path == paths[1]) {
              for (let j in state.routerPath.children[i].children) {
                if (state.routerPath.children[i].children[j].path == paths[2]) {
                  state.indexActive = [i, j];
                }
              }
            }
          }
        }
      }, 100);
    },
    //清空路由
    clearNewRouter(state) {
      state.newRouterList = [];
    },
    //设置新路由表
    setNewRouter(state, e) {
      state.newRouterList = [];
      let list = e.routerArr;
      list[0].alias = '/'
      for (let i in list) {
        list[i].meta.title = i18n.t(`menu.${list[i].name}`);
        //统计页面
        if (list[i].path == 'statistics') {
          //是否中台
          if (e.platformCode == 'superAdmin') {
            list[i].component = resolve => require(['@/views/' + list[i].path + '/middleground.vue'], resolve);
          } else {
            list[i].component = resolve => require(['@/views/' + list[i].path + '/platformSide.vue'], resolve);
          }
        } else {
          list[i].component = resolve => require(['@/views/' + list[i].path + '/index.vue'], resolve);
        }
        if (list[i].children && list[i].children.length > 0) {
          list[i].children[0].alias = '';

          for (let j in list[i].children) {
            list[i].children[j].meta.title = i18n.t(
              `menu.${list[i].children[j].name}`
            );
            list[i].children[j].component = resolve => require(['@/views/' + list[i].path + '/' + list[i].children[j].path + '/index.vue'], resolve);
            if (list[i].children[j].children && list[i].children[j].children.length > 0) {
              list[i].children[j].children[0].alias = '';
              for (let k in list[i].children[j].children) {
                list[i].children[j].children[k].meta.title = i18n.t(
                  `menu.${list[i].children[j].children[k].name}`
                );
                delete list[i].children[j].children[k].children;
                list[i].children[j].children[k].component = resolve => require(['@/views/' + list[i].path + '/' + list[i].children[j].path + '/' + list[i].children[j].children[k].path + '.vue'], resolve);
              }
            }
          }
        }
      }



      state.regionList = [{
        text: i18n.t('config.text1'),
        id: 'cn'
      }, {
        text: i18n.t('config.text2'),
        id: 'jp'
      }, {
        text: i18n.t('config.text3'),
        id: 'usa'
      },
      {
        text: i18n.t('config.text4'),
        id: 'eur'
      },
      {
        text: i18n.t('config.text35'),
        id: 'sea'
      }
      ];

      let arr1 = routerListA;
      arr1[0].children = list;
      router.addRoutes(arr1);
      state.newRouterList = arr1;
    }
  },
  actions: {
    //获取平台方信息
    getInfoByDomain({ commit }) {
      if (localStorage.getItem('platformData')) {
        let localPlatformData = JSON.parse(localStorage.getItem('platformData'))
        commit('setInfoByDomain', localPlatformData);
      }
      let domain = window.location.host.replace("www.", "");
      return requst.getInfoByDomain(domain).then((res) => {
        if (res.code != 0) {
          ElementUI.Message.error(i18n.t('config.text12'));
          localStorage.clear();
          sessionStorage.clear();
          router.push({ path: "/login" });
        }
        commit('setInfoByDomain', res.data);
        localStorage.setItem('platformData', JSON.stringify(res.data));
        // 设置路由表
        if (!localStorage.getItem('menuTree')) {
          return
        }
        commit('setNewRouter', { routerArr: JSON.parse(localStorage.getItem('menuTree')), platformCode: res.data.platformCode })
        commit('setRouterPath', { path: window.location.hash.substring(1, window.location.hash.length) })
        commit('setDefaultActive', { path: window.location.hash.substring(1, window.location.hash.length) })
      });

    },
    //区域切换
    switchRegionActions({ rootState }, regin) {
      if (regin == rootState.currentRegion) {
        return
      }
      return requst.switchRegion({ target: rootState.regionList[regin].id }).then((res) => {
        window.location.href = res.data
      });
    }
  },
  modules: {
  }
})
